import { ReactNode } from 'react';
import { useContentProtection } from '@/hooks/use-content-protection';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ContentProtectionWrapperProps {
  children: ReactNode;
  showSecurityBanner?: boolean;
  preventScreenshot?: boolean;
  preventCopy?: boolean;
  preventRightClick?: boolean;
  preventTextSelection?: boolean;
  preventPrint?: boolean;
  preventDevTools?: boolean;
  watermark?: boolean;
  preventScreenCapture?: boolean; // NEW: Prevent browser screen recording API
  preventKeyboardLock?: boolean; // NEW: Lock keyboard screenshot keys
  blurOnInactive?: boolean; // NEW: Blur content when tab is inactive
}

export function ContentProtectionWrapper({
  children,
  showSecurityBanner = true,
  preventScreenshot = true,
  preventCopy = true,
  preventRightClick = true,
  preventTextSelection = true,
  preventPrint = true,
  preventDevTools = false,
  watermark = false,
  preventScreenCapture = true, // NEW
  preventKeyboardLock = true, // NEW
  blurOnInactive = true, // NEW
}: ContentProtectionWrapperProps) {
  const { t } = useTranslation();

  useContentProtection({
    preventScreenshot,
    preventCopy,
    preventRightClick,
    preventTextSelection,
    preventPrint,
    preventDevTools,
    watermark,
    preventScreenCapture,
    preventKeyboardLock,
    blurOnInactive,
  });

  return (
    <div className="content-protected">
      {showSecurityBanner && (
        <Alert className="mb-4 border-red-500 bg-red-50 dark:bg-red-950">
          <ShieldAlert className="h-4 w-4 text-red-600" />
          <AlertTitle className="text-red-800 dark:text-red-200 font-semibold">
            {t('common.security.protectedContent.title', '🔒 Security Notice')}
          </AlertTitle>
          <AlertDescription className="text-red-700 dark:text-red-300 text-sm">
            {t(
              'common.security.protectedContent.description',
              'Prohibited keys: PrtScn, Win+Shift+S, Alt+PrtScn, Ctrl+P. Violations will log you out.'
            )}
          </AlertDescription>
        </Alert>
      )}
      {children}
    </div>
  );
}
